// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"384":"060787d11cea7316","847":"148d8936d806d671"}[chunkId] + ".css";
};